export { default } from './MyArchivedTasksList';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyArchivedTasksList/index.js